import {authMiddleware} from "./loginAction";
import cfg, {formatStatusError, handleResponse, handlePrepareData} from "../constants";

// usersAction - get users
export const usersAction = (filter, signal) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/ba/users', {
    method: "POST",
    body: JSON.stringify(filter),
    headers,
    signal
  }).then(handleResponse).then(handlePrepareData);
};

// userGetAction - get user by ID
export const userGetAction = (id) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/ba/user/' + id, {
    method: "GET",
    headers
  }).then(handleResponse).then((data) => {
    if (data.status === 'ok') {
      return data.user;
    }
    if (data.errors && data.errors.length > 0) {
      throw new Error(data.errors[0]);
    }
    throw new Error('error_other');
  });
};

// userDeleteAction - delete user by ID
export const userDeleteAction = (id) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/ba/user/' + id, {
    method: "DELETE",
    headers
  }).then(handleResponse).then(handlePrepareData);
};

// userStatusAction - change user status by ID
export const userStatusAction = (user_id, block_user) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/ba/user-change-block', {
    method: "POST",
    body: JSON.stringify({user_id, block_user}),
    headers
  }).then(handleResponse).then(handlePrepareData);
};

// userCreateAction - create user
export const userCreateAction = (data) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/ba/user-create', {
    method: "POST",
    headers,
    body: JSON.stringify(data)
  }).then(handleResponse).then(handlePrepareData);
};

// userEditAction - edit user profile
export const userEditAction = (item) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/ba/user', {
    method: "POST",
    headers,
    body: JSON.stringify(item)
  }).then(handleResponse).then(handlePrepareData);
};

// uploadUserPhotoAction - upload user avatar
export const uploadUserPhotoAction = (user_id, file) => (dispatch, getState) => {
  const token = authMiddleware(dispatch, getState, false, true);

  return new Promise((resolve, reject) => {
    const formData = new FormData();

    formData.append("user_id", user_id);
    if (file && file.name) {
      formData.append("file", file, file.name);
    }

    const req = new XMLHttpRequest();
    req.addEventListener("load", event => {
      if (req.status === 200) {
        try {
          let data = JSON.parse(req.response);
          if (data.status === 'ok') {
            resolve(data);
          } else if (data.errors && data.errors.length > 0) {
            reject(new Error(data.errors[0]));
          } else {
            reject(new Error('error_other'));
          }
        } catch (e) {
          reject(new Error('error_other'));
        }
      } else {
        reject(formatStatusError(req.status));
      }
    });

    req.upload.addEventListener("error", event => {
      reject(req.response);
    });

    req.open("POST", cfg.base_url + '/ba/user-upload-photo');
    req.setRequestHeader("Authorization", 'Bearer ' + token);
    req.send(formData);
  });
};

// curatorsAction - get curators list
export const curatorsAction = () => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/auth/users-curators-list', {
    method: "POST",
    headers
  }).then(handleResponse).then((data) => {
    if (data.status === 'ok') {
      return data.list;
    }
    if (data.errors && data.errors.length > 0) {
      throw new Error(data.errors[0]);
    }
    throw new Error('error_other');
  });
};

export const userFiredAction = (id) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/ba/user-fired/' + id, {
    method: "GET",
    headers
  }).then(handleResponse).then(handlePrepareData);
};

export const userFiredBackAction = (id) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/ba/user-fired-back/' + id, {
    method: "GET",
    headers
  }).then(handleResponse).then(handlePrepareData);
};

export const getCountClientsByProgramLevelAction = (data) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/ba/get-count-clients-by-program-level', {
    method: "POST",
    headers,
    body: JSON.stringify(data)
  }).then(handleResponse).then(handlePrepareData);
};

export const getShiftControlAction = (filter, signal) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/ba/get-shift-control', {
    method: "POST",
    body: JSON.stringify(filter),
    headers,
    signal
  }).then(handleResponse).then(handlePrepareData);
};

export const getResponseTimeAction = (filter, signal) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/ba/get-response-time', {
    method: "POST",
    body: JSON.stringify(filter),
    headers,
    signal
  }).then(handleResponse).then(handlePrepareData);
};

export const userChangeDayOffAction = (user_id, day_off) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/ba/user-change-day-off', {
    method: "POST",
    body: JSON.stringify({user_id, day_off}),
    headers
  }).then(handleResponse).then(handlePrepareData);
};

export const appointmentOfCuratorTempTaskAction = () => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/ba/appointment-of-curator-temp-task', {
    method: "POST",
    body: JSON.stringify({}),
    headers
  }).then(handleResponse).then(handlePrepareData);
};

